import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, listUsers, deleteUser } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';

import Loading from '../../../components/Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';

function UsersList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState(() => []);
  const [userSelected, setUserSelected] = useState('');
  const [disable, setDisable] = useState(true);

  const history = useHistory();

  const changeRole = (role) => {
    if (role === 'root') {
      role = 'Técnico'
    } else if (role === 'admin') {
      role = 'Administrativo'
    } else {
      role = 'Usuário'
    }
    return role;
  };

  const changeEndpointsviewer = (listEndpoint) => {
    if (listEndpoint === 'all') {
      listEndpoint = 'Todos'
    } else if (listEndpoint === 'none') {
      listEndpoint = 'Nenhum'
    } else {
      listEndpoint
    }
    return listEndpoint;
  };

  const changeQueuesviewer = (listQueues) => {
    if (listQueues === 'all') {
      listQueues = 'Todas'
    } else if (listQueues === 'none') {
      listQueues = 'Nenhuma'
    } else {
      listQueues
    }
    return listQueues;
  };

  const fetchUsers = async () => {
    const usersList = await listUsers();
    if (!usersList) return setLoading(true);

    const userPrepare = usersList.map((user) => {
      const chRole = changeRole(user.role);
      const chListEndpoints = changeEndpointsviewer(user.endpointsviewer);
      const chQueuesViewer = changeQueuesviewer(user.queuesviewer);

      user.role = chRole;
      user.endpointsviewer = chListEndpoints;
      user.queuesviewer = chQueuesViewer;

      return user;
    });
    // console.log(userPrepare)
    setUsers(userPrepare);
    setLoading(false);

    return true;
  };


  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const endpointsFetched = await fetchUsers();
    return endpointsFetched;
  }, []);

  const handleChangeSelectedUser = (element) => {
    setUserSelected(element);
    setDisable(false);
  };

  const handleClickDelete = async () => {
    const sendDeleteEndpoints = await deleteUser({ email: userSelected });
    window.location.reload();
    if(sendDeleteEndpoints.length === undefined) {
      toggleIsHidden('#alert-confirm-endpoints-delete');
      return toggleIsChangeFormElements('alert-endpoints-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    };
    toggleIsHidden('#alert-confirm-endpoints-delete');
    setDisable(true);
    toggleIsHidden('#buttons');
    validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(userSelected);
    return history.push('/config/usuarios/id');
  };

  const handleChangeSelectAll = () => {
    const inputSelectAll = document.getElementById('select-all');
    const selectEndopointsphones = phones.map((element) => {
      const getCheckbox = document.getElementById(element.endpoint);
      if(inputSelectAll.checked) {
        getCheckbox.checked = true;
        setDisable(false);
        return element.endpoint;
      } else {
        getCheckbox.checked = false;
        setDisable(true);
        return null;
      }
    });
    const result = selectEndopointsphones[0] === null ? [] : selectEndopointsphones;
    return setUserSelected(result);
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">LISTA DE USUÁRIOS</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-endpoints-not-delete" name="alert-endpoints-not-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-endpoints-not-delete') }></button>
            </div>
            <div className="message-body">
              Usuário removido com sucesso!.
            </div>
          </article>
          <article id="alert-confirm-endpoints-delete" name="alert-confirm-endpoints-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-endpoints-delete') }></button>
            </div>
            <div className="message-body">
              Tem certeza que quer deletar o usuário selecionado?
            </div>
            <br />
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered is-active">
              <button className="button is-danger is-half mx-3 px-5" type="submit" onClick={ () => handleClickDelete() }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Confirmar
                    </span>
              </button>
              <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                toggleIsHidden('#alert-confirm-endpoints-delete')
                toggleIsHidden('#buttons')
              }}>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Cancelar
                    </span>
              </button>
            </div>
          </div>
          </article>
          <article id="alert-create-endpoints" name="alert-create-endpoints" className="column is-half is-offset-one-quarter message is-warning is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Ramais deletados com sucesso!
            </div>
          </article>
          <div className="table-container is-flex-wrap-wrap">
            <table id="tableCalls" className="table is-hoverable is-striped is-fullwidth">  
              <thead>
                  <tr className='is-size-7 has-text-centered'>
                  <th scope="col"></th>
                  <th scope="col">Nome</th>
                  <th scope="col">E-mail</th>
                  <th scope="col">Ramal</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Status</th>
                  <th scope="col">Visão Ramais</th>
                  <th scope="col">Visão Filas</th>
                  </tr>
              </thead>
              <tbody>
              {
                users.map((user) => {
                  const { name, email, endpoint, role, endpointsviewer, queuesviewer, active } = user;

                  return (
                    <tr className='is-size-7 has-text-centered' key={ email }>
                      <td><input id={ email } type="radio" name="user" value={ email } onClick={ (e) => handleChangeSelectedUser(e.target.value)}/></td>
                      <td>{name}</td>
                      <td>{email}</td>
                      <td>{endpoint}</td>
                      <td>{role}</td>
                      <td>{active === true ? 'Ativo' : 'Desativado'}</td>
                      <td>{endpointsviewer}</td>
                      <td>{queuesviewer}</td>
                    </tr>)
                })
              }
              </tbody>
            </table>
          </div>
          <div className="columns">
            <div id="buttons" className="column is-half is-offset-one-quarter has-text-centered is-active">
                <button
                  className="button is-info is-half mx-3 px-6" type="submit" onClick={ () => handleClickUpdate() } disabled={ disable }>
                      <span className="icon">
                        <FontAwesomeIcon icon={ faPen } fixedWidth />
                      </span>
                      <span>
                        Alterar
                      </span>
                </button>
                <button
                  className="button is-danger is-half mx-3 px-6"
                  type="submit"
                  onClick={ () => {
                    toggleIsHidden('#alert-confirm-endpoints-delete')
                    toggleIsHidden('#buttons')
                    }}
                  disabled={ disable }
                >
                      <span className="icon">
                        <FontAwesomeIcon icon={ faTrash } fixedWidth />
                      </span>
                      <span>
                        Deletar
                      </span>
                </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default UsersList;
